@if (isMobileOrTablet()) {
  <!-- Horizontal Scrolling Tabs — mobile + tablet (no sidebar) -->
  <nav class="flex flex-row gap-4 pl-4 overflow-x-auto scrollbar-hide" role="tablist">
    @if (hasProducts()) {
      @for (product of productsSig(); track product.code) {
        <button 
          class="relative flex items-center px-4 py-3 whitespace-nowrap transition-all duration-200 flex-shrink-0"
          [class]="currentProductCode() === product.code 
            ? 'bg-brand-purple-50 rounded-t-xl text-brand-purple-700 font-semibold active-tab-mobile' 
            : 'text-base-600 font-medium hover:text-base-500'"
          [attr.aria-selected]="currentProductCode() === product.code"
          [attr.aria-controls]="'panel-' + product.code"
          role="tab"
          (click)="selectProduct(product)">
          
          <!-- Product Name -->
          <span class="text-base leading-none">{{ product.name }}</span>

          <!-- Inverted corner notches for active tab -->
          @if (currentProductCode() === product.code) {
            <span class="notch-mobile notch-left"></span>
            <span class="notch-mobile notch-right"></span>
          }
        </button>
      }
    } @else {
      <div class="text-center py-4 text-gray-400 w-full">
        <p class="text-sm">No products available</p>
      </div>
    }
  </nav>
} @else {
  <!-- Desktop: Vertical Tab Navigation — sidebar only (1024px+) -->
  <nav class="flex flex-col gap-4 pt-8" role="tablist">
    @if (hasProducts()) {
      @for (product of productsSig(); track product.code) {
        <button 
          class="group relative flex items-center pr-4 text-left transition-all duration-200
            "
          [class]="currentProductCode() === product.code 
            ? 'h-14 bg-brand-purple-50 rounded-l-xl text-brand-purple-700 font-semibold active-tab' 
            : 'h-12 text-base-600 font-medium hover:text-base-500'"
          [attr.aria-selected]="currentProductCode() === product.code"
          [attr.aria-controls]="'panel-' + product.code"
          role="tab"
          (click)="selectProduct(product)">
          
          <!-- Product Name -->
          <span class="flex-1 text-base leading-none hover:bg-brand-purple-50 hover:text-brand-purple-700 py-4 pl-4 rounded-xl">{{ product.name }}</span>
          
          <!-- Price (if enabled) -->
          @let price = getProductPriceFrom(product);
          @if (showPricing() && price) {
            <span class="text-xs text-gray-500 ml-2">{{ price }}</span>
          }
          
          <!-- Inverted corner notches for active tab (Figma: Subtract boolean operations) -->
          @if (currentProductCode() === product.code) {
            <span class="notch notch-top"></span>
            <span class="notch notch-bottom"></span>
          }
        </button>
      }
    } @else {
      <!-- Empty State -->
      <div class="text-center py-8 text-gray-400">
        <div class="text-3xl mb-2">📦</div>
        <p class="text-sm">No products available</p>
      </div>
    }
  </nav>
}
